import {connect} from 'react-redux';
import Owners from 'app/components/RightBarPane/Property/Owners';
import {convertListToArray} from 'app/shared/utils';

export const mapStateToProps = (state) => ({
    owners: convertListToArray(state.getIn(['property', 'selectedProperty', 'owners'])),
});

export default connect(mapStateToProps, null)(Owners);